import { Search } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useSearch } from "../hooks/useSearch";
import { getProductPdpUrl } from "../../../utils/url.utils";
import { useState, useEffect } from "react";

export default function HomeSearch() {
  const navigate = useNavigate();

  const {
    searchSectionRef,
    inputRef,
    isSearchActive,
    query,
    setQuery,
    results,
    loading,
    handleFocus,
    closeSearch,
  } = useSearch();

   // NEW STATE
  const [activeIndex, setActiveIndex] = useState(-1);

  // safe limited list
  const visibleResults = Array.isArray(results)
    ? results.slice(0, 8)
    : [];

  // Highlight function
  const highlightText = (text, highlight) => {
    if (!highlight) return text;

    const parts = text.split(new RegExp(`(${highlight})`, "gi"));

    return parts.map((part, i) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <mark key={i}>{part}</mark>
      ) : (
        part
      )
    );
  };

  // scroll active item
  useEffect(() => {
    if (activeIndex < 0) return;
    const el = document.querySelector(".active-item");
    if (el) el.scrollIntoView({ block: "nearest" });
  }, [activeIndex]);



  return (
    <>
      <div
        ref={searchSectionRef}
        className={`search-wrapper bg-white rounded shadow ${isSearchActive ? "active" : ""
          }`}
      >
        <div className="d-flex position-relative">

          {/* INPUT */}
          <input
            ref={inputRef}
            className="form-control border-0 input_home"
            placeholder="WHAT ARE YOU LOOKING FOR?"
            value={query}
            onFocus={handleFocus}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) =>
              setQuery(
                e.target.value
                  .replace(/[^a-zA-Z0-9 ]/g, "")
                  .replace(/^\s+/, "")
              )
            }
             onKeyDown={(e) => {
              if (!visibleResults.length && e.key !== "Enter") return;

              // DOWN
              if (e.key === "ArrowDown") {
                e.preventDefault();
                setActiveIndex((prev) =>
                  prev < visibleResults.length - 1 ? prev + 1 : 0
                );
              }

              // UP
              if (e.key === "ArrowUp") {
                e.preventDefault();
                setActiveIndex((prev) =>
                  prev > 0 ? prev - 1 : visibleResults.length - 1
                );
              }

              // ENTER
              if (e.key === "Enter") {
                e.preventDefault();

                const trimmed = query.trim();

                if (activeIndex >= 0 && visibleResults[activeIndex]) {
                  closeSearch();
                } else if (trimmed) {
                  closeSearch();
                  navigate(`/search?q=${encodeURIComponent(trimmed)}`);
                }
              }
            }}
          />

          {/* SEARCH BUTTON */}
          <button
            type="button"
            className="btn btn-dark button_search"
            disabled={!query.trim()}
            onClick={() => {
              closeSearch();
              navigate(`/search?q=${encodeURIComponent(query.trim())}`);
            }}
          >
            <Search strokeWidth={1.25} />
          </button>

          {/* AUTOCOMPLETE */}
          {isSearchActive && query && (
            <div className="autocomplete-box">

              {loading && (
                <div className="p-3 text-center">Searching...</div>
              )}

              {!loading && visibleResults.length === 0 && (
                <div className="p-3 text-center">No results found</div>
              )}

              {!loading &&
                visibleResults.map((item, i) => (
                  <Link
                    key={item.id}
                    to={getProductPdpUrl(item.action_url, item.sku)}
                    className={`autocomplete-item ${
                      i === activeIndex ? "active-item" : ""
                    }`}
                    onMouseEnter={() => setActiveIndex(i)} // ✅ hover sync
                    onClick={closeSearch}
                  >
                    <img
                      src={item.media_list?.main?.file}
                      alt={item.name}
                      className="autocomplete-img"
                    />

                    <span className="autocomplete-text">
                      {highlightText(item.name, query)}
                    </span>
                  </Link>
                ))}
            </div>
          )}
        </div>
      </div>

      {/* OVERLAY */}
      {isSearchActive && (
        <div className="search-overlay" onClick={closeSearch} />
      )}

      <style jsx>{`
        .search-wrapper.active {
          position: fixed;
          bottom: 320px;
          max-width: 600px;
        }

        .autocomplete-box {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          background: #fff;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          max-height: 320px;
          overflow-y: auto;
          z-index: 9999;
        }

        .autocomplete-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 15px;
          text-decoration: none;
          color: #333;
          border-bottom: 1px solid #eee;
        }

        .autocomplete-item:hover {
          background: #f7f7f7;
        }

        .autocomplete-img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 4px;
        }

        .autocomplete-text {
          flex: 1;
          font-size: 14px;
        }

        mark {
          background-color:transparent;
          padding: 0;
          font-weight: 600;
        }
      `}</style>
    </>
  );
}